import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchCustomerRegion = () => {
  return apiClient(ENDPOINTS.CUSTOMERREGION, {
    method: "GET",
  });
};

export const fetchCustomerSubRegion = () => {
  return apiClient(ENDPOINTS.CUSTOMERSUBREGION, {
    method: "GET",
  });
};

export const createCustomerRegion = (customerregiondata) => {
  return apiClient(
    ENDPOINTS.CUSTOMERREGIONPOST,
    { method: "POST", body: customerregiondata },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const createCustomerSubRegion = (customerSubregiondata) => {
  return apiClient(
    ENDPOINTS.CUSTOMERSUBREGIONPOST,
    { method: "POST", body: customerSubregiondata },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const deleteCustomerRegion = async (id) => {
  await apiClient(ENDPOINTS.CUSTOMERREGION_BY_ID(id), {
    method: "DELETE",
  });
  return id;
};

export const deleteCustomerSubRegion = async (id) => {
  await apiClient(ENDPOINTS.DELETE_CUSTOMER_SUBREGION(id), {
    method: "DELETE",
  });
  return id;
};

export const updateCustomerRegion = (id, data) => {
  return apiClient(ENDPOINTS.CUSTOMERREGION_BY_ID(id), {
    method: "PUT",
    body: { id, ...data },
  });
};

export const updateCustomerSubRegion = (id, data) => {
  return apiClient(ENDPOINTS.UPDATE_CUSTOMER_SUBREGION(id), {
    method: "PUT",
    body: { id, ...data },
  });
};
